import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./motion";

const FEATURES = [
  {
    id: "feature-card-microgrid",
    n: "I",
    title: "10 MW Captive Microgrid Enclosures",
    body: "Standardized, liquid-cooled modular units integrated with dedicated off-grid power hosting to bypass compromised localized utilities entirely.",
  },
  {
    id: "feature-card-zero-fault",
    n: "II",
    title: "100% Zero-Fault Connectivity Guarantee",
    body: "Direct, zero-latency telemetry routing backed by a contractually enforced Uptime Service Level Agreement (SLA).",
  },
  {
    id: "feature-card-satellite-shield",
    n: "III",
    title: "Ground-to-Space Satellite Shield",
    body: "Integrated high-throughput tracking arrays delivering automated, instant failover data loops directly to international cloud infrastructure regardless of terrestrial conditions.",
  },
];

export const Resiliency = () => {
  return (
    <section data-testid="resiliency-section" className="border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-6"
        >
          02 / System Architecture &amp; Constraint Resiliency
        </motion.p>

        <motion.h2
          variants={fadeUp}
          custom={1}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="font-display text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight font-bold text-white max-w-3xl"
        >
          Regional Midstream Constraint Resiliency
        </motion.h2>

        <motion.div
          variants={fadeUp}
          custom={2}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-10 grid grid-cols-12 gap-8"
        >
          <p className="col-span-12 lg:col-span-7 text-sm sm:text-base leading-relaxed text-zinc-400">
            As multiple global resource extraction, mining, and joint-venture energy
            corporations continue to scale high-density automation, public utility
            infrastructures present critical operational exposure. Localized terrestrial
            grids paralyzed by systemic blackouts, public pipeline drops, and vulnerable
            subsea networks introduce immediate data-blindness risks and severe regulatory
            compliance liabilities.
          </p>
          <p className="col-span-12 lg:col-span-5 text-sm sm:text-base leading-relaxed text-zinc-300 lg:border-l lg:border-zinc-800 lg:pl-8">
            Project Equinox completely operationalizes this midstream constraint through
            fully insulated, plug-and-play architectural hardware sanctuaries:
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 border border-zinc-800">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.id}
              data-testid={f.id}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className="group relative p-8 lg:p-10 border-zinc-800 border-t first:border-t-0 md:border-t-0 md:border-l md:first:border-l-0 hover:bg-white transition-colors duration-500 cursor-default"
            >
              <span className="font-display text-4xl font-black text-outline group-hover:[-webkit-text-stroke:1px_#d4d4d8] transition-all duration-500">
                {f.n}
              </span>
              <h3 className="font-display mt-8 text-lg lg:text-xl uppercase font-bold tracking-tight text-white group-hover:text-black transition-colors duration-500 leading-snug">
                {f.title}
              </h3>
              <p className="mt-4 text-xs leading-relaxed text-zinc-400 group-hover:text-zinc-700 transition-colors duration-500">
                {f.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
